import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'

import { TRANSLATION_KEYS } from '../../translations'

import styles from './NotApplicableCategory.module.scss'

interface INotApplicableCategoryProps {
  category: string
}

export const NotApplicableCategory: FC<INotApplicableCategoryProps> = ({ category }) => {
  return (
    <div className={styles.root}>
      <Translation span text={category} />
      <Translation span text={TRANSLATION_KEYS.applicablePlaceholder} />
    </div>
  )
}
